<template>
<Layout>
  <div class="section content">
    <h1 class="is-size-5">ประทับ</h1>
    <span class="is-size-7">
      <p>
        778mobile GmbH<br>
        HRB 79227 // USt-IdNr: DE303966009<br>
        Mei Li-BERLIT, manager director<br>
        Am Wehrhahn 50<br>
        DE-40211 Düsseldorf - Germany<br>
        Telefon: 08005895405<br>
        E-Mail: cuca@778mobile.com
      </p>
    </span>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/TH/Imprint.vue